import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation } from 'react-query';
import { addFlexMatchPreferredEmployee } from 'RestAPIs/flex-match';

export type AddFlexMatchPreferredEmployeePayload = {
  requestId: number;
  body: {
    employeeId: number;
    createdBy: string;
    bpmTaskId: string;
  };
};

const useAddFlexMatchPreferredEmployee = () => {
  return useMutation(
    (payload: AddFlexMatchPreferredEmployeePayload) =>
      addFlexMatchPreferredEmployee(payload),
    {
      onSuccess: () => {
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useAddFlexMatchPreferredEmployee;
